import React from 'react';
import { BlockContainer } from '@atlassian/jira-common-directory-v2/src/components/text-cell/styled';

export default function Key({ value }: { value: string }) {
	return <BlockContainer>{value}</BlockContainer>;
}
